import {
  Input,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import RadioCards from "components/RadioCards";
import { DETACHED_PREFIX } from "constants/proposals";
import { modalTypes } from "constants/types";
import { func, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import classes from "./DetachDocumentModal.module.scss";

const DetachDocumentModal = ({ documentName, onConfirm }) => {
  const dispatch = useDispatch();
  const [deleteDocument, setDeleteDocument] = useState(undefined);
  const [newDocumentName, setNewDocumentName] = useState(
    `${DETACHED_PREFIX}${documentName}`
  );
  const isNameEmpty = !newDocumentName?.trim();

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.DETACH_DOCUMENT_MODAL));
  };

  const onClickConfirm = () => {
    dispatch(hideModal(modalTypes.DETACH_DOCUMENT_MODAL));
    onConfirm({ deleteDocument, newDocumentName });
  };

  return (
    <Modal
      data-testid="detach-document-modal"
      className="fade-in"
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Detach link</Modal.Header>

      <Modal.Body>
        <p>
          You&apos;re about to remove the link between the document{" "}
          <strong>{documentName}</strong> and the outline.
        </p>
        <p>Choose how you want to proceed:</p>

        <RadioCards
          options={[
            {
              label: (
                <span>
                  I want to <strong>delete</strong> the old child associated doc
                </span>
              ),

              value: true,
            },
            {
              align: "start",
              label: (
                <div className={classes["document_name"]}>
                  I want to <strong>Keep</strong> the old child associated doc
                  <Input
                    className={classes["document_name__input"]}
                    disabled={deleteDocument !== false}
                    label="Name Of Detached Doc"
                    onChange={setNewDocumentName}
                    value={newDocumentName}
                  />
                </div>
              ),

              value: false,
            },
          ]}
          onChange={setDeleteDocument}
          value={deleteDocument}
        />
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="confirm-button"
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
          disabled={isNameEmpty || deleteDocument === undefined}
        >
          Confirm Action
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

DetachDocumentModal.propTypes = {
  documentName: string.isRequired,
  onConfirm: func.isRequired,
};

export default DetachDocumentModal;
